import React, { useState } from "react";
import Forms from '../../Forms/forms'
import './styles.scss'

const ContactForm = () => {

    // const form = new Forms;

    // const [formData,setFormData] = useState((e) => ({
    //     name: '',
    //     email: '',
    //     message: ''
    // }))

    // const [errors,setErrors] = useState({
    //     name: false,
    //     email: false,
    //     message: false
    // })

    // const handleChange = (e) => {
    //     let { name, value } = e.target;
    //     let nextData = {...formData}
    //     let nextErrors = {...errors}
    //     nextData[name] = value;
    //     nextErrors[name] = false;
    //     setFormData(nextData)
    //     setErrors(nextErrors)
    // }

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     let nextErrors = {...errors}
    //     Object.keys(formData).forEach(key => {
    //         if(!formData[key]) {
    //             nextErrors[key] = true
    //         }
    //     })
    //     if(!errors['email'] && !errors['message']) {
    //         setErrors(nextErrors)
    //     }
    // }

    return(
        <div className="contact-form">
            <p className="message">
                Feel free to email me at <a href="mailto:jcbART@gmail.com">jcbART@gmail.com</a>
            </p>
        </div>
    )
}
export default ContactForm;